import { render, staticRenderFns } from "./PartnerLink.vue?vue&type=template&id=b03fe824&scoped=true&"
import script from "./PartnerLink.vue?vue&type=script&lang=js&"
export * from "./PartnerLink.vue?vue&type=script&lang=js&"
import style0 from "./PartnerLink.vue?vue&type=style&index=0&id=b03fe824&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b03fe824",
  null
  
)

export default component.exports